export default __webpack_public_path__ + "static/char-v-40-ja-adba1e36e98b132be519c46903dec984.mp4";